module.exports = __webpack_public_path__ + "img/I-28.d89f283b.svg";